<template>
  <background-layout>
    <div class="flex flex-center container">
      <q-card class="card q-mx-auto">
        <form @submit.prevent="handleLogin">
          <q-card-section class="q-py-lg">
            <picture>
              <source srcset="@/assets/logo.webp" type="image/webp" />
              <img class="block q-mx-auto" src="@/assets/logo.png" width="300" alt="logo" />
            </picture>
          </q-card-section>

          <q-card-section>
            <div class="row q-col-gutter-md">
              <div class="col-12">
                <q-input
                  v-model="email"
                  autofocus
                  type="email"
                  label="Email"
                  bottom-slots
                  no-error-icon
                  :error="getErrorState($v.email)"
                >
                  <template #append>
                    <q-icon name="email" />
                  </template>

                  <template #error>
                    <span v-if="!$v.email.required">Email is required</span>
                    <span v-else-if="!$v.email.email">Email must be an email</span>
                  </template>
                </q-input>
              </div>

              <div class="col-12">
                <q-input
                  v-model="password"
                  type="password"
                  label="Password"
                  error-message="Password is required"
                  no-error-icon
                  :error="getErrorState($v.password)"
                >
                  <template #append>
                    <q-icon name="lock" />
                  </template>
                </q-input>
              </div>

              <div class="col-6">
                <q-checkbox v-model="rememberMe" label="Remember me" />
              </div>

              <div class="col-6 forgot">
                <router-link to="/forgotPassword"> Forgot password? </router-link>
              </div>
            </div>
          </q-card-section>

          <q-card-actions>
            <q-btn type="submit" class="block full-width" color="primary" label="Log In" :loading="isLoading" />
          </q-card-actions>

          <q-card-section class="text-center">
            <p>Don't have an account? <router-link to="/register">Register</router-link></p>
          </q-card-section>
        </form>
      </q-card>
    </div>
  </background-layout>
</template>

<script>
import BackgroundLayout from '@/layouts/BackgroundLayout.vue';
import { mapActions, mapState } from 'vuex';
import getErrorState from '@/utils/getErrorState';
import { getErrorMessage } from '@/utils';
import { email, required } from 'vuelidate/lib/validators';

export default {
  components: {
    BackgroundLayout,
  },
  data() {
    return {
      email: '',
      password: '',
      rememberMe: false,
      isLoading: false,
    };
  },

  computed: {
    ...mapState(['user']),
  },

  methods: {
    getErrorState,
    ...mapActions(['login']),

    async handleLogin() {
      this.$v.$reset();
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      }

      try {
        this.isLoading = true;

        await this.login({
          email: this.email,
          password: this.password,
          rememberMe: this.rememberMe,
        });

        await this.$router.push('/');
      } catch (err) {
        this.$q.notify({
          message: getErrorMessage(err),
          group: true,
          timeout: 1000,
          type: 'negative',
        });
      } finally {
        this.isLoading = false;
      }
    },
  },

  validations: {
    email: {
      required,
      email,
    },
    password: {
      required,
    },
  },
};
</script>
<style scoped>
.card {
  width: 40rem;
  max-width: 80vw;
}

.forgot {
  margin: auto;
  text-align: right;
}
.container {
  height: 80vh;
}
</style>
